import StarIcon from "./home/Images/Star.svg";
import StarFreeIcon from "./home/Images/StarFree.svg";
import LoveIcon from "./home/Images/loveicon.png";
import AddIcon from "./home/Images/add.png";
import { Link, useNavigate } from "react-router-dom";
import * as Wish from "../network/api/wish";
import Rating from "react-rating";
import Price from "./productdetails/details/description/Price.js";
import Imgedd from "./home/Images/man_3.png";
import cookies from "js-cookie";
import { useTranslation } from "react-i18next";
function Card(props) {
  const { t, i18n } = useTranslation();
  const token = cookies.get("user");
  const navigate = useNavigate();

  const addToWish = async () => {
    await Wish.addWish(props.id).then((e) => {
      props.update_p();
    });
  };
  const totalDiscountToday = (props?.product?.todayDiscount || []).reduce(
    (sum, m) => sum + m.discount,
    0
  );
  const totalDiscountFlash = (props?.product?.flashDiscount || []).reduce(
    (sum, m) => sum + m.discount,
    0
  );

  return (
    <div
      className="card"
      style={{
        height: "433px",
        width: "250px !important",
        overflowX: "hidden",
      }}
    >
      <div className="card-image">
        <img
          src={props.ImageCard}
          className="card-img"
          style={{ width: "250px " }}
        />
        {/* <img src={Imgedd} className='card-img' alt='' /> */}
        {props.personal?.wish?.includes(props.id) ? (
          <svg
            className="love"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="30"
            viewBox="0 0 32 30"
            fill="none"
          >
            <g filter="url(#filter0_d_3_2)">
              <mask
                id="mask0_3_2"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="0"
                width="24"
                height="22"
              >
                <path d="M4 0H28V21.037H4V0Z" fill="white" />
              </mask>
              <g mask="url(#mask0_3_2)">
                <mask
                  id="mask1_3_2"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="4"
                  y="-1"
                  width="25"
                  height="23"
                >
                  <path
                    d="M5.80681 3.87722L5.80668 3.87743C4.18039 6.56127 5.28615 9.18404 6.79297 10.6355L16.1667 19.6441L25.3106 10.6985C26.7229 9.11492 27.2068 7.52516 26.9218 5.76389L26.9218 5.76379C26.5231 3.29783 24.4892 1.37209 21.9677 1.09717C20.4103 0.929055 18.927 1.37006 17.7723 2.331C17.4599 2.59108 17.1815 2.881 16.9388 3.19597L16.1625 4.20369L15.3666 3.21131C15.0789 2.85264 14.7384 2.5211 14.3484 2.22393L5.80681 3.87722ZM5.80681 3.87722C6.70413 2.39556 8.10968 1.40029 9.63548 1.10459M5.80681 3.87722L9.63548 1.10459M9.63548 1.10459C11.279 0.788851 12.9961 1.1946 14.3481 2.22367L9.63548 1.10459Z"
                    fill="white"
                    stroke="white"
                    stroke-width="2"
                  />
                </mask>
                <g mask="url(#mask1_3_2)">
                  <path
                    d="M4.95145 3.35919C3.00546 6.57061 4.3766 9.69639 6.09921 11.3557L16.1729 21.0371L26.0336 11.3901C27.6359 9.60534 28.2501 7.7122 27.909 5.60418C27.4376 2.68828 25.039 0.425938 22.0757 0.103021C20.2582 -0.0933522 18.5028 0.42208 17.1324 1.56251C16.7636 1.86961 16.4341 2.21259 16.1467 2.58566C15.806 2.16089 15.4063 1.77277 14.9542 1.42825C13.3785 0.228793 11.3727 -0.247673 9.44605 0.122697C7.6212 0.476092 5.98347 1.6551 4.95145 3.35919Z"
                    fill="black"
                    stroke="black"
                    stroke-width="2"
                  />
                </g>
              </g>
            </g>
            <defs>
              <filter
                id="filter0_d_3_2"
                x="0"
                y="0"
                width="32"
                height="29.037"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_3_2"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_3_2"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        ) : token ? (
          <img
            src={LoveIcon}
            alt="love-icon"
            className="love"
            onClick={() => {
              addToWish();
            }}
          />
        ) : (
          <Link to="#Login" data-bs-toggle="modal">
            <img src={LoveIcon} alt="love-icon" className="love" />
          </Link>
        )}
        {token ? (
          <img
            src={AddIcon}
            alt="add-icon"
            className="add"
            onClick={() => {
              window.scrollTo(0, 0);
              navigate(`/productdetails/${props.id}`);
            }}
          />
        ) : (
          <Link to="#Login" data-bs-toggle="modal">
            {" "}
            <img src={AddIcon} alt="add-icon" className="add" />
          </Link>
        )}
        {props.new && <span className="new">{t("new")}</span>}
      </div>
      <div
        className="card-content p-2 "
        style={{ cursor: "pointer" }}
        onClick={() => {
          window.scrollTo(0, 0);
          navigate(`/productdetails/${props.id}`);
        }}
      >
        {props.brand?.name && <h3>{props.brand?.name}</h3>}

        <p>
          {i18n.language == "en"
            ? props?.product?.name
            : props?.product?.name_ar}
        </p>
        <div className="sub-cat-card-price-before rtl-div ">
          {+props.price_after - totalDiscountFlash - totalDiscountToday}{" "}
          <span>{t("curency")} </span>{" "}
        </div>
        <div>
          <Rating
            initialRating={Math.ceil(props?.product?.rating)}
            readonly
            emptySymbol={<img src={StarFreeIcon} className="star" alt="" />}
            fullSymbol={<img src={StarIcon} className="star" alt="" />}
          />
        </div>
      </div>
    </div>
  );
}
export default Card;
